import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService, HttpMethod} from '../../base-api.service';
import {RecipesModelService} from '../../../Models/YuChef/Recipes/recipes-model.service';
import {RecipeStoreForm} from '../../../../Models/YuChef/Recipe/recipe-store.model';
import {RecipeStepStoreForm} from '../../../../Models/YuChef/Recipe/recipe-step-store.model';
import {RecipeIngredientStoreForm} from '../../../../Models/YuChef/Recipe/recipe-ingredient-store.model';
import {RecipeResultStoreForm} from '../../../../Models/YuChef/Recipe/recipe-result-store.model';

@Injectable({
  providedIn: 'root'
})
export class RecipesApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: RecipesModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener las recetas
   *
   */
  public getRecipes(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getRecetas', {}).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener una receta
   *
   */
  public getRecipeDetail(params: { id_receta: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getReceta', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener familias recetas
   *
   */
  public getRecipesFamilies(): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getRecetasFamilias', {}, 'get').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar receta
   *
   */
  public setRecipe(params: RecipeStoreForm): Promise<ApiResponse> {
    const endpoint: string = params.id ? 'kitchen/recipes/' + params.id : 'kitchen/recipes';
    const formData = params.asFormData();

    if (params.id) {
      formData.append('_method', 'PATCH');
    }

    return new Promise((resolve, reject) => {

      return this.httpCall(endpoint, formData, 'post').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });
  }


  /**
   * Eliminar receta
   *
   */
  public deleteRecipe(id: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall(`kitchen/recipes/${id}`, {}, 'delete').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar ingrediente receta
   *
   */
  public setRecipeIngredient(recipeId: number, params: RecipeIngredientStoreForm): Promise<ApiResponse> {
    const endpoint: string = params.id ? `kitchen/recipes/${recipeId}/ingredients/${params.id}` : `kitchen/recipes/${recipeId}/ingredients`;
    const method: HttpMethod = params.id ? 'patch' : 'post';

    return new Promise((resolve, reject) => {

      return this.httpCall(endpoint, params, method).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });
  }


  /**
   * Eliminar un ingrediente de la receta
   *
   */
  public deleteIngredient(recipeId: number, ingredientId: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall(`kitchen/recipes/${recipeId}/ingredients/${ingredientId}`, {}, 'delete').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar resultado receta
   *
   */
  public setRecipeResult(recipeId: number, params: RecipeResultStoreForm): Promise<ApiResponse> {
    const endpoint: string = params.id ? `kitchen/recipes/${recipeId}/results/${params.id}` : `kitchen/recipes/${recipeId}/results`;
    const method: HttpMethod = params.id ? 'patch' : 'post';

    return new Promise((resolve, reject) => {

      return this.httpCall(endpoint, params, method).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });
  }


  /**
   * Eliminar un resultado de la receta
   *
   */
  public deleteResult(recipeId: number, resultId: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall(`kitchen/recipes/${recipeId}/results/${resultId}`, {}, 'delete').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar paso receta
   *
   */
  public setRecipeStep(recipeId: number, params: RecipeStepStoreForm): Promise<ApiResponse> {
    const endpoint: string = params.id ? `kitchen/recipes/${recipeId}/steps/${params.id}` : `kitchen/recipes/${recipeId}/steps`;
    const method: HttpMethod = params.id ? 'patch' : 'post';

    return new Promise((resolve, reject) => {

      return this.httpCall(endpoint, params, method).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });
  }


  /**
   * Eliminar paso de receta
   *
   */
  public deleteStep(recipeId: number, stepId: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall(`kitchen/recipes/${recipeId}/steps/${stepId}`, {}, 'delete').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }

}
